import FeaturedTalks from './featured-talks';

export default FeaturedTalks;
